import {useState,useEffect} from 'react';


const UseWindowResize = ()=>{
 
    const [state,setState] = useState({width:null,height:null});
    function updateWindowDeminsions(){
      setState({width:window.innerWidth,height:window.innerHeight});
    }
    useEffect(()=>{
      if (typeof window !== 'undefined') {
      updateWindowDeminsions();
      window.addEventListener('resize',updateWindowDeminsions);
      return ()=> window.removeEventListener('resize',updateWindowDeminsions)
      }
    },[])
    return [state.width,state.height]
  
 
}
export default UseWindowResize;